/**
 * @prettier
 */
import {getUserData} from '../api/login';
import listingActions from '../actions/listingActions';
import travelerActions from '../actions/travelerActions';

function fetchUserData(store) {
    const state = store.getState();
    const system = state.systemReducer;

    // TODO replace this with await?
    return getUserData({useMockData: system.useMockData}).then((response) => {
        if (response.body) {
            store.dispatch(listingActions.fetchUserDataSuccess(response.body));
        }
    });
}

function fetchUserDataAndSetLoggedIn(store) {
    const state = store.getState();
    const system = state.systemReducer;

    // TODO replace this with await?
    return getUserData({useMockData: system.useMockData}).then((response) => {
        if (response.body) {
            store.dispatch(listingActions.fetchUserDataSuccess(response.body));
            store.dispatch(travelerActions.setUserLoggedIn());
        }
    });
}

export {fetchUserData, fetchUserDataAndSetLoggedIn};
